module.exports = __webpack_public_path__ + "img/right-hand.e45bb44f.png";